import ENV from 'web-app/config/environment';
const TypedENV = ENV;
// `process` exists only in the webpack projects (Sign-In), added by webpack.EnvironmentPlugin
// `ENV` is an object if used with the main app (created by Ember)
const EnvironmentIsFunction = (env) => typeof env === 'function';
const CURRENT_PLATFORM = EnvironmentIsFunction(TypedENV)
    ? process.env.FAMLY_PLATFORM
    : TypedENV.APP.platform;
const CURRENT_STORE = EnvironmentIsFunction(TypedENV)
    ? process.env.STORE
    : TypedENV.APP.store;
const WHITELABEL_APP_ID = EnvironmentIsFunction(TypedENV)
    ? process.env.WHITELABEL_APP_ID
    : TypedENV.APP.whitelabelAppId;
const IS_DEVELOPMENT = EnvironmentIsFunction(TypedENV)
    ? process.env.NODE_ENV !== 'production'
    : TypedENV.isDevelopment;
const APP = EnvironmentIsFunction(TypedENV)
    ? {
        version: '',
        buildNumber: '',
    }
    : TypedENV.APP;
export default {
    CURRENT_PLATFORM,
    CURRENT_STORE,
    IS_DEVELOPMENT,
    APP,
    WHITELABEL_APP_ID,
};
